import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {FtBomGroup} from "../models/basic/ft-bom-group";
import {FtBom} from "../models/basic/ft-bom";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";

export type FtBomGroupFilter = Filters & {
    search: string;
    ordering: string;
};

export class FtBomGroupService extends AbstractService<FtBomGroup> {

    constructor() {
        super(URLS.FT_BOM_GROUP);
    }

    async export_xlsx(filters?: FtBomGroupFilter): Promise<AxiosResponse<{ hash: string }>> {
        const path = `${this.path}/export_xlsx/`;
        const allParams = this.processParameters(filters);

        return await trackPromise(Api.get(path, {params: allParams}));
    }

    async get_export_status(hash: string): Promise<AxiosResponse<{ status: number }>> {
        const path = `${this.path}/get_export_status/`;
        return await trackPromise(Api.get(path, {params: {hash}}));
    }
  
    async associateGroup(id: number, ftboms: FtBom[]): Promise<AxiosResponse<{ftboms: FtBom[]}>> {
        let items = [];
        for (const item of ftboms) {
            items.push(item.foxconn_part_number);
        }
        const path = `${this.path}${id}/associate-group/`;
        
        return await trackPromise(Api.post(path, {items: items}));
    }
    
    async disassociateGroup(foxconn_part_number: string): Promise<AxiosResponse> {
        const path = `${this.path}/disassociate-group/?foxconn_part_number=${foxconn_part_number}`;
        return await trackPromise(Api.post(path));
    }

}
